import { generateResourceReducer } from '../generators/resource.reducer';

import * as types from './calendar-item.types';
import * as constants from './calendar-item.constants';

export const calendarItemReducer = generateResourceReducer<types.ICalendarItem>({
  STORE: constants.STORE_CALENDAR_ITEM,
  CLEAR: constants.CLEAR_CALENDAR_ITEM,
});
